// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Oa7c","question":"styles_question__2dqBm","inputVisibleButton":"styles_inputVisibleButton__2zml6","note":"styles_note__2cHn9"};